import { render, staticRenderFns } from "./parentingAudio_1.0.vue?vue&type=template&id=15b9aa68&scoped=true"
import script from "./parentingAudio_1.0.vue?vue&type=script&lang=js"
export * from "./parentingAudio_1.0.vue?vue&type=script&lang=js"
import style0 from "./parentingAudio_1.0.vue?vue&type=style&index=0&id=15b9aa68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b9aa68",
  null
  
)

export default component.exports